import { CommonFunctions } from '../static/common-functions';
import { BaseBus } from './BaseBus';
import { DateFunctions } from '../static/date-functions';

export class KudosAndOpportunityBus extends BaseBus
{
    constructor(data: KudosAndOpportunityBus) {
        super(data);
    }
    CID(): any {
        return this.id;
    }
    setId(id: any) {
        this.id = id;
    }
    setParentId(id: any) {
        this.referenceId = id;
    }

    initialize(data: KudosAndOpportunityBus) {
    super.initialize(data);
    try {
      this.insertDt = CommonFunctions.getDate(data.insertDt);
      this.updateDt = CommonFunctions.getDate(data.updateDt);
      this.dateOccurred = CommonFunctions.getDate(data.dateOccurred);
    }
    catch {

    }

    }
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null) {
       // this.insertDt = date;
       // this.insertUserId = userId;
    }
    setFromForm(data: KudosAndOpportunityBus) {
        super.setFromForm(data);
      }
    setCommon(userId: any, date: Date, companyId: any = null, personId: any = null) {
        if (!CommonFunctions.hasValue(this.insertDt)) {
            this.insertDt = date;
            this.insertUserId = userId;
        }
        this.updateDt = date;
        this.updateUserId = userId;
    }
    setBeforeSave() {
        this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
        this.updateDt = DateFunctions.getDateTimeWithUTCOffset(this.updateDt);
        this.dateOccurred = DateFunctions.getDateOnly(this.dateOccurred);
    }
    id: any;
    referenceId: any;
    dispatchId: any;
    categoryId: any;
    categoryName: string;
    comments: string;
    person: string;

    whoEnteredPerson: string;
    personId: any;
    dateOccurred: Date;
    insertUserId: any;
    insertDt: Date;
    updateUserId: any;
    updateDt: Date;
    recordType: string;
}
